var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pa-8",attrs:{"cols":"12"}},[_c('h2',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.module.name))]),_c('v-divider'),_c('p',{staticClass:"text-pre-wrap font-weight-light pt-3"},[_vm._v(_vm._s(_vm.module.description))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }